<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('promotional_process')"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('promotional_process')"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('registration_date_between')" class="mb-0">
                            <v-date-picker v-model="datatable.queryParams.filter.registration_date_between" is-range>
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 mr-1">
                                                <input :value="inputValue.start"
                                                       v-on="inputEvents.start"
                                                       :placeholder="$t('start_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 ml-1">
                                                <input :value="inputValue.end"
                                                       v-on="inputEvents.end"
                                                       :placeholder="$t('end_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                </template>
                            </v-date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('campus')">
                            <campus-selectbox
                                v-model="datatable.queryParams.filter.campus_id"
                            ></campus-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="datatable.queryParams.filter.faculty_code"></faculty-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('name')">
                            <b-form-input
                                v-model="datatable.queryParams.filter.name_surname">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('department')">
                            <department-selectbox :faculty_code="datatable.queryParams.filter.faculty_code"
                                                  v-model="datatable.queryParams.filter.department_code"></department-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('national_id')">
                            <b-form-input type="text" v-model="datatable.queryParams.filter.national_id"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('program')">
                            <program-selectbox v-model="datatable.queryParams.filter.program_code"
                                               :faculty_code="datatable.queryParams.filter.faculty_code"></program-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('city')">
                            <city-selectbox v-model="datatable.queryParams.filter.city" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                v-model="datatable.queryParams.filter.academic_year"
                            ></academic-years-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('current_district')">
                            <district-outline-selectbox
                                v-model="datatable.queryParams.filter.district_id"
                                :city_id="datatable.queryParams.filter.city_id"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                       @on-page-change="onPageChange" @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable">
            </datatable>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from "@/layouts/AppLayout"
    import Header from "@/layouts/AppLayout/Header"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    //Component
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";
    import CommonModal from "@/components/elements/CommonModal";
    import CampusSelectbox from "@/components/interactive-fields/CampusSelectbox.vue";
    import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
    import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox.vue";

    //Other
    import qs from 'qs'
    //Service
    import PromotionalProcessService from "@/services/PromotionalProcessService";

    export default {
        components: {
            DistrictOutlineSelectbox,
            CitySelectbox,
            CampusSelectbox,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
        },
        metaInfo() {
            return {
                title: this.$t('promotional_process')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess:null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: []
                        },
                        {
                            label: this.$t('national_id'),
                            field: 'national_id',
                            sortable: true,
                        },
                        {
                            label: this.$t('name'),
                            field: 'name',
                            sortable: true,
                        },
                        {
                            label: this.$t('surname'),
                            field: 'surname',
                            sortable: true,
                        },
                        {
                            label: this.$t('faculty'),
                            field: this.getLocaleField('faculty_name'),
                            sortable: true,
                        },
                        {
                            label: this.$t('program'),
                            field: this.getLocaleField('program_name'),
                            sortable: true,
                        },
                        {
                            label: this.$t('order_of_preference'),
                            field: 'osym_points',
                            sortable: true,
                        },
                        {
                            label: this.$t('registration_date_just'),
                            field: 'osym_points',
                            sortable: true,
                        },
                        {
                            label: this.$t('mobile_number'),
                            field: 'mobile_tel',
                            sortable: true,
                        },
                        {
                            label: this.$t('email'),
                            field: 'email',
                            sortable: true,
                        },
                        {
                            label: this.$t('success_order'),
                            field: 'id',
                            sortable: true,
                        },
                        {
                            label: this.$t('point_type'),
                            field: 'id',
                            sortable: true,
                        },
                        {
                            label: this.$t('apply_bau_application'),
                            field: 'id',
                            sortable: true,
                        },
                        {
                            label: this.$t('diploma'),
                            field: 'id',
                            sortable: true,
                        },
                        {
                            label: this.$t('high_school'),
                            field: 'school',
                            sortable: true,
                        },
                        {
                            label: this.$t('city'),
                            field: this.getLocaleField('city_name'),
                            sortable: true,
                        },
                        {
                            label: this.$t('campus'),
                            field: this.getLocaleField('campus_name'),
                            sortable: true,
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            }
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return PromotionalProcessService.getAll(config)
                                  .then((response) => {
                                      this.datatable.rows = response.data.data
                                      this.datatable.total = response.data.pagination.total
                                  })
                                  .finally(() => {
                                      this.datatable.isLoading = false;
                                  });
            },
        }
    };
</script>

